import React from 'react';
import { motion } from 'framer-motion';
import Hotkeys from 'react-hot-keys';
import { useDispatch } from 'react-redux';
import { toggleGoogleReviewDialog } from '../../store/actions/session';
import { GOOGLE_REVIEW_SEARCH_SELECT } from '../../api/constants';
import { fetchDoc } from '../../store/actions/login';

const GoogleReviewDialog2: React.FC<{ docid?: string }> = ({ docid }): JSX.Element => {
    const dispatch = useDispatch();

    const close = async () => {
        dispatch(toggleGoogleReviewDialog(undefined));
        dispatch(fetchDoc());
    };

    return (
        <Hotkeys keyName="esc" onKeyDown={close}>
            <motion.div
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                style={{ zIndex: 20 }}
                transition={{ duration: 0.2, ease: 'linear' }}
                className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-lato"
            >
                <div className="modal-overlay" onClick={close}></div>
                <div className="modal-content w-60p h-3/4 flex flex-col">
                    <div className="flex items-center justify-between p-16 rounded-t-4 bg-neutral-9">
                        <p className="text-13 leading-5 bold text-neutral-1">
                            Search & Select Your Google Listing
                        </p>
                        <div
                            onClick={close}
                            className="flex items-center justify-center w-16 h-16 cursor-pointer"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 320 512"
                                className="w-16 h-16 fill-neutral-1"
                            >
                                <path d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
                            </svg>
                        </div>
                    </div>
                    <div className="flex items-start w-full p-16 flex-1 overflow-auto">
                        <div className="w-full h-full space-y-24">
                            <iframe
                                width="100%"
                                height="100%"
                                src={GOOGLE_REVIEW_SEARCH_SELECT(docid || '')}
                            />
                        </div>
                    </div>
                </div>
            </motion.div>
        </Hotkeys>
    );
};

export default GoogleReviewDialog2;
